import { takeLatest, put, all, call } from 'redux-saga/effects';
import { usersAPI } from 'resources/api';
import { toFormData } from 'utils';
import Types from './types';
import { goBack } from 'connected-react-router';
import { processError } from 'state/utils';

function* fetchStartAsync() {
  try {
    const res = yield usersAPI.getAll();
    yield put({ type: Types.FETCH_SUCCESS, payload: res });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.FETCH_ERROR, payload: message });
  }
}

function* fetchStart() {
  yield takeLatest(Types.FETCH_START, fetchStartAsync);
}

function* updateStartAsync({ payload }) {
  try {
    const { user, goBack: shouldGoBack = true } = payload;
    const form = toFormData(user);
    
    yield usersAPI.update(form);
    yield put({ type: Types.UPDATE_SUCCESS, payload: user });
    yield put({ type: Types.FETCH_START });

    if(shouldGoBack) yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.UPDATE_ERROR, payload: message });
  }
}

function* updateStart() {
  yield takeLatest(Types.UPDATE_START, updateStartAsync);
}

function* createStartAsync({ payload }) {
  try {
    const form = toFormData(payload);
    yield usersAPI.create(form);
    yield put({ type: Types.CREATE_SUCCESS, payload });
    yield put({ type: Types.FETCH_START });
    yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.CREATE_ERROR, payload: message });
  }
}

function* createStart() {
  yield takeLatest(Types.CREATE_START, createStartAsync);
}

function* deleteStartAsync({ payload }) {
  try {
    yield usersAPI.delete(payload);
    yield put({ type: Types.DELETE_SUCCESS, payload });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.DELETE_ERROR, payload: message });
  }
}

function* deleteStart() {
  yield takeLatest(Types.DELETE_START, deleteStartAsync);
}

function* unregisterStartAsync({ payload }) {
  try {
    yield usersAPI.unregister(payload);
    yield put({ type: Types.UNREGISTER_SUCCESS, payload });
    yield put({ type: Types.FETCH_START, payload: {} });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.UNREGISTER_ERROR, payload: message });
  }
}

function* unregisterStart() {
  yield takeLatest(Types.UNREGISTER_START, unregisterStartAsync);
}

export default function* sagas() {
  yield all([call(fetchStart), call(updateStart), call(createStart), call(deleteStart), call(unregisterStart)]);
}
